import 'lazysizes'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Routes } from 'react-router-dom'

import Main from '@/pages/Main/Main'
import NotFound from '@/pages/NotFound/NotFound'
import ResultsTable from '@/pages/ResultsTable'
import {
  setStoreCities,
} from '@/store/slices/app'

import './App.css'

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    fetch('cities.json')
      .then((r) => r.json())
      .then((r) => {
        dispatch(setStoreCities(r.values || []))
      })
      .catch((err) => console.error('Error fetching cities.json:', err))
  }, [dispatch])

  return (
    <Routes>
      <Route
        path="/"
        element={<Main />}
      />
      <Route 
        path="/:cityName"
        element={<Main />}
      />
      <Route path="/результаты" element={<ResultsTable />} />
      <Route path="/results" element={<ResultsTable />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
